var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8688 14H2.8C2.58783 14 2.38434 13.9157 2.23431 13.7657C2.08429 13.6157 2 13.4122 2 13.2V2.8C2 2.58783 2.08429 2.38434 2.23431 2.23431C2.38434 2.08429 2.58783 2 2.8 2H13.2C13.4122 2 13.6157 2.08429 13.7657 2.23431C13.9157 2.38434 14 2.58783 14 2.8V8.8688C14 9.08082 14 9.99631 14 9.99631L10 14C10 14 9.08082 14 8.8688 14Z",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14V10.6768C10 10.4973 10.0713 10.3252 10.1982 10.1982C10.3252 10.0713 10.4973 10 10.6768 10H14",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgNote;